import React from 'react'
import { checkTextTranslation, translate } from '../../utils/useful'

class SidesInput extends React.Component {
    state = {
        locked: true,
        values: {},
        sides: ['top', 'right', 'bottom', 'left']
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data != this.props.data) {
            this.init()
        }
    }


    init() {

        if (this.props.data) {
            let sections = String(this.props.data).split(' ')
            let values = {}
            let sides = this.state.sides
            let tempValues = []
            let tempUnits = []
            let locked = true
            let tempSection

            sections.forEach(section => {

                if (tempSection && tempSection != section) {
                    locked = false
                }
                tempSection = section
               
                if (!section.includes('%')) {
                    tempValues.push(Number(section.replace('px', '')))
                    tempUnits.push('px')
                } else {
                    tempValues.push(Number(section.replace('%', '')))
                    tempUnits.push('%')
                }
            });


            sides.forEach((side, index) => {
                let myIndex = index % sections.length
                values[side] = { value: (tempValues[myIndex] == 0 ? '' : tempValues[myIndex]), unit: tempUnits[myIndex] }
            });

            this.setState({ values, locked })
            // console.log(values)
        }
    }



    changeInputValue(value) {

        this.props.changeValue(this.props.header.key, value, this.props.extra)

    }

    changeInput = (key, value) => {

        let maxValue = this.props.header.information?.maxValue
        if (maxValue != null && value > maxValue) {
            return
        }
        let sides = this.state.sides
        let values = { ...this.state.values }

        let output
        if (this.state.locked) {
            output = value + 'px'
            // sides.forEach(side => {
            //     values[side] = { value, unit: 'px' }
            // });

        } else {
            values[key] = { value: (value ?? 0), unit: 'px' }
            output = ''
            sides.forEach(side => {
                let sideValue = values[side]?.value
                if (sideValue == '' || !sideValue) {
                    sideValue = 0
                }

                output = output + sideValue + 'px '
            });

        }

        // console.log(values)
        // console.log(output)
        // this.setState({ values })
        this.changeInputValue(output)


    }


    render() {


        return (
            <div className="w-100 h-100 flexc">

                {this.state.sides.map((side, index) => {
                    return (

                        <div className='mrd-1'>
                            <div className={this.props.inputClass}>
                                <input disabled={this.props.header.information.disabled} autoFocus={this.props.header.information.autoFocus} ref={el => this.input = el} type="number" step="any" value={this.state.values[side]?.value != null ? this.state.values[side]?.value : ''} maxLength={this.props.header.information.maxLength} onChange={(e) => this.changeInput(side, e.target.value)} placeholder={translate('-')} className="transpanet-input text-center text-smaller" />
                            </div>
                            <p className='text-smallest mt-1 color-gray-2 text-center'>{translate(side)}</p>
                        </div>

                    )
                })}

                {/* <div className='mrd-1'>
                    <div className={this.props.inputClass}>
                        <input disabled={this.props.header.information.disabled} autoFocus={this.props.header.information.autoFocus} ref={el => this.input = el} type="number" step="any" value={this.state.values[]} maxLength={this.props.header.information.maxLength} onChange={(e) => this.changeInput('right', e.target)} placeholder={translate('-')} className="transpanet-input text-center text-smaller" />
                    </div>
                    <p className='text-smallest mt-1 color-gray-2 text-center'>{translate("Right")}</p>
                </div>
                <div className='mrd-1'>
                    <div className={this.props.inputClass}>
                        <input disabled={this.props.header.information.disabled} autoFocus={this.props.header.information.autoFocus} ref={el => this.input = el} type="number" step="any" value={this.state.values[]} maxLength={this.props.header.information.maxLength} onChange={(e) => this.changeInput('bottom', e.target)} placeholder={translate('-')} className="transpanet-input text-center text-smaller" />
                    </div>
                    <p className='text-smallest mt-1 color-gray-2 text-center'>{translate("Bottom")}</p>
                </div>
                <div className='mrd-1'>
                    <div className={this.props.inputClass}>
                        <input disabled={this.props.header.information.disabled} autoFocus={this.props.header.information.autoFocus} ref={el => this.input = el} type="number" step="any" value={this.state.values[]} maxLength={this.props.header.information.maxLength} onChange={(e) => this.changeInput('left', e.target)} placeholder={translate('-')} className="transpanet-input text-center text-smaller" />
                    </div>
                    <p className='text-smallest mt-1 color-gray-2 text-center'>{translate("Left")}</p>
                </div> */}

                <div>
                    <button onClick={() => this.setState({ locked: !this.state.locked })} className={"flexcc " + this.props.inputClass}>
                        <img src='/assets/icons/useful/broken-link.svg' height={16} style={{ opacity: this.state.locked ? 1 : 0.5, filter: this.state.locked ? "" : 'grayscale(100%)' }} />
                    </button>
                    <p className='text-smallest mt-1 color-gray-2  text-center'>{translate("Lock")}</p>

                </div>


            </div>
        )
    }
}

export default SidesInput;